import { render, staticRenderFns } from "./DockList.vue?vue&type=template&id=111b15ba&scoped=true&"
import script from "./DockList.vue?vue&type=script&lang=js&"
export * from "./DockList.vue?vue&type=script&lang=js&"
import style0 from "./DockList.vue?vue&type=style&index=0&id=111b15ba&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "111b15ba",
  null
  
)

export default component.exports